import { Box, IconChevron } from 'braid-design-system';
import React, { Fragment } from 'react';

import {
  MyProfileButton,
  MyPreferencesButton,
  SavedBusinessesButton,
  SavedSearchesButton,
  AdvertiseWithUsButton,
  SignOutButton,
  ManageMyAdsButton,
} from '../Dropdown/DropdownButtons';
import { DropdownDivider } from '../Dropdown/DropdownDivider';
import { NavHeading } from '../Dropdown/DropdownHeading';
import { LegacyProfileIcon } from '../LegacyIcons/LegacyProfileIcon';
import {
  desktopHeaderProfileButtonId,
  desktopHeaderProfileDropdownMenuId,
} from '../utils/generalUtils';

import * as styles from './ProfileActionsLoggedIn.css';

interface ProfileActionsLoggedInProps {
  variant: 'logged-in-buyer' | 'logged-in-client';
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const ProfileActionsLoggedIn = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: ProfileActionsLoggedInProps) => (
  <Box position="relative">
    <button
      id={desktopHeaderProfileButtonId}
      className={styles.profileButton}
      aria-label="Profile menu"
    >
      <LegacyProfileIcon tone="black" className={styles.profileIcon} />

      <span className={styles.profileButtonChevron}>
        <IconChevron />
      </span>
    </button>

    <ProfileDropdownMenu
      variant={variant}
      baseUrl={baseUrl}
      advertiserCentreUrl={advertiserCentreUrl}
    />
  </Box>
);

interface ProfileDropdownMenuProps {
  variant: 'logged-in-buyer' | 'logged-in-client';
  baseUrl: string;
  advertiserCentreUrl: string;
}

const ProfileDropdownMenu = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: ProfileDropdownMenuProps) => (
  <Box
    id={desktopHeaderProfileDropdownMenuId}
    data={{ testid: 'desktop-navigation-header-profile-dropdown' }}
    className={styles.profileDropdownMenu}
  >
    <Box paddingBottom="small">
      {variant === 'logged-in-client' && (
        <Fragment>
          <NavHeading>Advertiser Centre</NavHeading>
          <ManageMyAdsButton advertiserCentreUrl={advertiserCentreUrl} />

          <DropdownDivider />
        </Fragment>
      )}

      <NavHeading>Buying a business</NavHeading>
      <MyProfileButton baseUrl={baseUrl} />
      <MyPreferencesButton baseUrl={baseUrl} />
      <SavedBusinessesButton baseUrl={baseUrl} />
      <SavedSearchesButton baseUrl={baseUrl} />

      <DropdownDivider />

      {variant === 'logged-in-buyer' && (
        <Fragment>
          <NavHeading>Selling a business</NavHeading>
          <AdvertiseWithUsButton baseUrl={baseUrl} />

          <DropdownDivider />
        </Fragment>
      )}

      <SignOutButton baseUrl={baseUrl} />
    </Box>
  </Box>
);
